<template>
  <div>
    <div class="heaer-text">华为报表</div>
    <huawei-filter
      @tableColumn="tableColumn"
      @downloadData="downloadData"
      @getPopuInfo="getPopuInfo"
    ></huawei-filter>
    <div>
      <huawei-table
        :list="list"
        :column="column"
        :loading="loading"
        ref="usertable"
        :totalColumn="totalColumn"
        @computTotalColumn="computTotalColumn"
        :downColunm="downloadColumn"
      ></huawei-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[16, 50, 100, 200]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
import HuaweiFilter from "./huaweiFilter";
import HuaweiTable from "./huaweiTable";
import { huaweiRportColumn } from "../../config/table_comlun";
import { getPopuInfoFetch } from "../../api/api";
export default {
  name: "HuaweiReport",
  components: { HuaweiFilter, HuaweiTable },
  data() {
    return {
      column: huaweiRportColumn,
      list: [],
      totalColumn: [],
      loading: false,
      // page: 1,
      // size: 16,
      sum: [],
      // total: 0,
      // downloadDataSource: [],
      downloadColumn: huaweiRportColumn,
    };
  },
  methods: {
    computTotalColumn() {},
    tableColumn(arr) {
      this.column = arr;
    },
    downloadData() {
      // getPopuInfoFetch({ data: JSON.stringify({ ...param }) })
      //   .then((result) => {
      //     const { code, huaweiPopuDatas } = result;
      //     if (code == "0000") {
      //       let temp = huaweiPopuDatas.splice(0, 1);

      //       this.downloadColumn.map((item) => {
      //         item.value = temp[0][item.key];
      //       });

      //       console.log(this.column, "ddd");
      //       this.downloadDataSource = huaweiPopuDatas;
      //     }
      //   })
      //   .then(() => {
      this.$refs.usertable.downLoadFileToExcel();
      // });
    },
    // handleSizeChange(size) {
    //   console.log(size, "size");
    // },
    // handleCurrentChange(page) {
    //   console.log(page, "page");
    // },
    getPopuInfo(param) {
      getPopuInfoFetch({
        data: JSON.stringify({ ...param }),
      }).then((result) => {
        const { code, huaweiPopuDatas } = result;
        if (code == "0000") {
          // this.totalColumn = huaweiPopuDatas.splice(0, 1);
          let temp = huaweiPopuDatas.splice(0, 1);

          this.column.map((item) => {
            item.value = temp[0][item.key];
          });

          console.log(this.column, "ddd");
          this.list = huaweiPopuDatas;
          // this.total = totalCount;
        }
      });
    },
  },
};
</script>
<style scoped>
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
</style>
